 window.onload = () => {
    const createFilterButtons = () => {
      const collectionTitle = document.querySelector('.SectionHeader__Heading')?.textContent.trim() || 'コレクション';
      const collectionUrl = window.location.pathname.split('/').pop();

      const filters = {
        色: { id: 'color-filter-section', pc: '#snize_filters_block_filter_option_2c9f66a4492e0de878125477485d750b li', mobile: '.snize-filter-checkbox input[name="filter_option_2c9f66a4492e0de878125477485d750b"]', param: 'filter_option_2c9f66a4492e0de878125477485d750b' },
        幅: { id: 'width-filter-section', pc: '#snize_filters_block_filter_ptag_89de0cd6766f3213b015d83fafb2ffe0 li', mobile: '.snize-filter-checkbox input[name="filter_ptag_89de0cd6766f3213b015d83fafb2ffe0"]', param: 'filter_ptag_89de0cd6766f3213b015d83fafb2ffe0' },
        奥行: { id: 'depth-filter-section', pc: '#snize_filters_block_filter_ptag_b8c34b03a46e5fb9183e55efe2a75a44 li', mobile: '.snize-filter-checkbox input[name="filter_ptag_b8c34b03a46e5fb9183e55efe2a75a44"]', param: 'filter_ptag_b8c34b03a46e5fb9183e55efe2a75a44' },
        高さ: { id: 'height-filter-section', pc: '#snize_filters_block_filter_ptag_54d1152c3828ee1bc835ddf21fc4a2a0 li', mobile: '.snize-filter-checkbox input[name="filter_ptag_54d1152c3828ee1bc835ddf21fc4a2a0"]', param: 'filter_ptag_54d1152c3828ee1bc835ddf21fc4a2a0' },
        生地名: { id: 'fabric-filter-section', pc: '#snize_filters_block_filter_ptag_416ec584bbf35b160f76f9031e2dc21f li', mobile: '.snize-filter-checkbox input[name="filter_ptag_416ec584bbf35b160f76f9031e2dc21f"]', param: 'filter_ptag_416ec584bbf35b160f76f9031e2dc21f' },
        素材: { id: 'material-filter-section', pc: '#snize_filters_block_filter_ptag_e0cacb5b372fbe26518f11883944ee3b li', mobile: '.snize-filter-checkbox input[name="filter_ptag_e0cacb5b372fbe26518f11883944ee3b"]', param: 'filter_ptag_e0cacb5b372fbe26518f11883944ee3b' },
      };

      Object.entries(filters).forEach(([key, filter]) => {
        const values = new Set([...document.querySelectorAll(filter.pc + ' input, ' + filter.mobile)].map(input => input.value?.trim()).filter(Boolean));

        const target = document.getElementById(filter.id);
        if (target && values.size) {
          const modifiedCollectionTitle = collectionTitle.replace(/\s+\S+$/, ''); // 右から一つ目以降の文字列を削除

          target.innerHTML = `
            <div class="filter-section">
              <h2 class="title-border">${modifiedCollectionTitle}を${key}で選ぶ</h2>
              <div class="color-button-wrapper">
                ${[...values].map(value => `<a href="https://interior-arne.com/collections/${collectionUrl}?page=1&rb_${filter.param}=${encodeURIComponent(value)}" class="color-button">${value}</a>`).join('')}
              </div>
            </div>`;
        }
      });
    };

    const observer = new MutationObserver(() => {
      if (Object.values(filters).find(filter => document.querySelector(filter.pc) || document.querySelector(filter.mobile))) {
        observer.disconnect();
        createFilterButtons();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(createFilterButtons, 1000);
  };